/* Quilted vest page (vest-buybox.liquid). Colour swatches and size buttons over hidden <select>s,
   per-colour photo gallery, colour rail, matching-leash add-on and checkout. The cart drawer
   (mitsi-cart.js) submits the form and reads window.NPKit for validity and the extra leash line.
   Vest only since 2026-10-30 (Walk Kit, booties and two-vest offers retired). */
(function () {
  'use strict';
  var node = document.getElementById('purchase-data');
  if (!node) return;

  var data = JSON.parse(node.textContent);
  var $ = function (id) { return document.getElementById(id); };
  var fmt = function (cents) { return cents % 100 ? '$' + (cents / 100).toFixed(2) : '$' + (cents / 100); };
  var colorSelect = $('main-color');
  var sizeSelect = $('main-size');
  var form = $('add-btn').closest('form');
  var params = new URLSearchParams(location.search);
  var key = 'mitsi-buying-' + data.mainHandle;
  var saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (e) {}
  window.variants = data.main;

  // Colour swatches replace the colour dropdown; the hidden <select> stays the source of truth.
  var swatchLabel = document.createElement('span');
  swatchLabel.className = 'selected-color-name';
  swatchLabel.setAttribute('aria-live', 'polite');
  colorSelect.closest('.option-field').querySelector('.option-heading').appendChild(swatchLabel);
  var swatchGroup = document.createElement('div');
  swatchGroup.className = 'color-swatches';
  swatchGroup.setAttribute('role', 'group');
  swatchGroup.setAttribute('aria-label', colorSelect.getAttribute('aria-label'));
  Array.from(colorSelect.options).filter(function (o) { return o.value; }).forEach(function (option) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'color-swatch';
    button.dataset.color = option.value;
    button.disabled = option.disabled;
    button.setAttribute('aria-label', option.textContent.trim());
    button.title = option.textContent.trim();
    var dot = document.createElement('span');
    dot.className = 'swatch-dot';
    dot.setAttribute('aria-hidden', 'true');
    button.appendChild(dot);
    button.addEventListener('click', function () {
      colorSelect.value = option.value;
      colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
    swatchGroup.appendChild(button);
  });
  colorSelect.hidden = true;
  colorSelect.insertAdjacentElement('afterend', swatchGroup);
  colorSelect.closest('.option-field').querySelector('label').removeAttribute('for');

  // Size buttons replace the size dropdown so a size sold out in the chosen colour shows crossed out.
  var sizeGroup = document.createElement('div');
  sizeGroup.className = 'size-pills';
  sizeGroup.dataset.kind = 'letter';
  sizeGroup.setAttribute('role', 'group');
  sizeGroup.setAttribute('aria-label', sizeSelect.getAttribute('aria-label'));
  var sizeDetail = document.createElement('p');
  sizeDetail.className = 'size-pill-detail';
  sizeDetail.setAttribute('aria-live', 'polite');
  Array.from(sizeSelect.options).filter(function (o) { return o.value; }).forEach(function (option) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'size-pill';
    button.dataset.size = option.value;
    var weight = /about ([\d–-]+ lb)/.exec(option.textContent);
    if (weight) {
      button.classList.add('has-weight');
      button.innerHTML = '<span class="sp-size"></span><span class="sp-weight"></span>';
      button.firstChild.textContent = option.value;
      button.lastChild.textContent = weight[1];
    } else {
      button.textContent = option.value;
    }
    button.addEventListener('click', function () {
      sizeSelect.value = option.value;
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
    sizeGroup.appendChild(button);
  });
  sizeSelect.hidden = true;
  sizeSelect.insertAdjacentElement('afterend', sizeGroup);
  sizeGroup.insertAdjacentElement('afterend', sizeDetail);
  sizeSelect.closest('.option-field').querySelector('label').removeAttribute('for');

  function selected() {
    return data.main.find(function (v) { return v.color === colorSelect.value && v.size === sizeSelect.value; });
  }
  // Price shown before a size is chosen: the chosen colour's first available size.
  function representative() {
    return selected() || data.main.find(function (v) { return v.available && v.color === colorSelect.value; }) ||
      data.main.find(function (v) { return v.available; }) || { cents: 0, cmp: 0, available: false };
  }
  function validValue(value, field) {
    return data.main.some(function (v) { return v.available && v[field] === value; });
  }
  function restore(select, value, field) {
    if (value && validValue(value, field)) select.value = value;
  }
  restore(colorSelect, saved.mainColor, 'color');
  restore(colorSelect, params.get('color'), 'color');
  restore(sizeSelect, saved.mainSize, 'size');
  // A link to one variant (?variant=, used by Shopify sharing and Google Shopping) opens on that colour and size.
  var linked = data.main.find(function (v) { return String(v.id) === params.get('variant') && v.available; });
  if (linked) { colorSelect.value = linked.color; sizeSelect.value = linked.size; }
  if (sizeSelect.value && !selected()) sizeSelect.value = '';

  function persist() {
    try { sessionStorage.setItem(key, JSON.stringify({ mainColor: colorSelect.value, mainSize: sizeSelect.value })); } catch (e) {}
  }

  function syncSizes() {
    sizeGroup.querySelectorAll('button').forEach(function (button) {
      var size = button.dataset.size;
      var v = data.main.find(function (x) { return x.color === colorSelect.value && x.size === size; });
      var soldOut = !!colorSelect.value && !(v && v.available);
      var option = Array.from(sizeSelect.options).find(function (o) { return o.value === size; });
      button.disabled = soldOut;
      if (option) option.disabled = soldOut;
      button.setAttribute('aria-label', soldOut ? size + ', sold out' : (option ? option.textContent.trim() : size));
      button.title = soldOut ? 'Sold out in ' + colorSelect.value.toLowerCase() : (option ? option.textContent.trim() : size);
      if (soldOut && sizeSelect.value === size) sizeSelect.value = '';
    });
    sizeGroup.querySelectorAll('button').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.size === sizeSelect.value));
    });
    var chosen = sizeSelect.options[sizeSelect.selectedIndex];
    sizeDetail.textContent = chosen && chosen.value ? chosen.textContent.trim() : '';
    sizeDetail.hidden = !sizeDetail.textContent;
  }

  function syncSwatches() {
    var name = colorSelect.value || 'Choose color';
    if (swatchLabel.textContent && swatchLabel.textContent !== name) {
      swatchLabel.classList.remove('v6-roll'); void swatchLabel.offsetWidth; swatchLabel.classList.add('v6-roll');
    }
    swatchLabel.textContent = name;
    swatchGroup.querySelectorAll('button').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.color === colorSelect.value));
    });
  }

  function focusMissing() {
    var target = !colorSelect.value ? colorSelect : !sizeSelect.value ? sizeSelect : null;
    if (!target) return false;
    var focusTarget = target.parentElement.querySelector('.color-swatch:not(:disabled), .size-pill:not(:disabled)') || target;
    focusTarget.focus({ preventScroll: true });
    target.closest('.option-field').scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
    $('purchase-error').textContent = 'Choose ' + target.getAttribute('aria-label').toLowerCase() + ' to continue.';
    $('purchase-error').hidden = false;
    return true;
  }

  // Gallery: every slide for the chosen colour lives in one track (swipe on phones, a stacked grid on
  // desktop). Photos load at one computed width so the preload and the shown image share a URL, and a
  // new colour is swapped in only once its first photo has decoded (max 450ms), so taps never flash.
  var galleryNode = $('gallery-data');
  var gallery = galleryNode ? JSON.parse(galleryNode.textContent) : {};
  var track = $('v6-track');
  var ticks = $('v6-ticks');
  var countNode = $('v6-count');
  var galleryIndex = 0;
  var shownColor = '';
  var preloaded = {};
  var swapToken = 0;
  var hasMotion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = matchMedia('(min-width: 901px)');
  function slides() { return gallery[colorSelect.value || 'Blue'] || gallery.Blue || []; }
  function isStudio(src) { return /\/(mc26-|vest-|detail-frontback)/.test(src); }
  function slideWidth(first) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var css = desktop.matches ? (track ? track.clientWidth : 800) / (first ? 1 : 2) : window.innerWidth;
    var steps = [480, 640, 960, 1280];
    for (var i = 0; i < steps.length; i += 1) if (steps[i] >= css * dpr) return steps[i];
    return 1280;
  }
  function sizedSrc(src, first) { return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + slideWidth(first); }
  function preload(url) {
    if (preloaded[url]) return preloaded[url];
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    preloaded[url] = (img.decode ? img.decode() : new Promise(function (r) { img.onload = r; })).catch(function () {});
    return preloaded[url];
  }
  function within(promise, ms) { return Promise.race([promise, new Promise(function (r) { setTimeout(r, ms); })]); }
  function markCurrent() {
    var figs = track.children;
    for (var i = 0; i < figs.length; i += 1) figs[i].classList.toggle('is-current', i === galleryIndex);
    if (ticks) Array.prototype.forEach.call(ticks.children, function (t, i) { t.classList.toggle('on', i === galleryIndex); t.classList.toggle('past', i < galleryIndex); });
    if (countNode) countNode.textContent = (galleryIndex + 1) + ' / ' + figs.length;
    var list = slides();
    if (list[galleryIndex]) $('gallery-caption').textContent = list[galleryIndex].caption;
    var old = $('pdp-main');
    var cur = figs[galleryIndex] && figs[galleryIndex].querySelector('img');
    if (cur && old !== cur) { if (old) old.removeAttribute('id'); cur.id = 'pdp-main'; }
  }
  function buildTrack(list) {
    var frag = document.createDocumentFragment();
    list.forEach(function (item, i) {
      var fig = document.createElement('figure');
      fig.className = 'v6-slide ' + (isStudio(item.src) ? 'is-studio' : 'is-photo');
      var img = document.createElement('img');
      img.decoding = 'async';
      img.loading = i < 2 ? 'eager' : 'lazy';
      img.alt = item.alt;
      img.width = 1600; img.height = isStudio(item.src) ? 1600 : 2000;
      img.src = sizedSrc(item.src, i === 0);
      fig.appendChild(img);
      frag.appendChild(fig);
    });
    track.innerHTML = '';
    track.appendChild(frag);
    track.scrollLeft = 0;
    if (ticks) { ticks.innerHTML = ''; list.forEach(function () { ticks.appendChild(document.createElement('span')); }); }
    markCurrent();
  }
  function updateGallery() {
    var list = slides();
    var color = colorSelect.value || 'Blue';
    if (!list.length || !track || color === shownColor) return;
    var first = !shownColor;
    shownColor = color;
    galleryIndex = 0;
    var token = ++swapToken;
    var ready = first ? Promise.resolve() : within(preload(sizedSrc(list[0].src, true)), 450);
    if (!first && hasMotion) track.classList.add('v6-leaving');
    ready.then(function () {
      if (token !== swapToken) return;
      buildTrack(list);
      track.classList.remove('v6-leaving');
      if (!first && hasMotion) { track.classList.remove('v6-entering'); void track.offsetWidth; track.classList.add('v6-entering'); }
      list.slice(1).forEach(function (item) { preload(sizedSrc(item.src, false)); });
    });
  }
  // Warm every colour's lead photo once the page is idle, so a colour tap is instant.
  (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () {
    Object.keys(gallery).forEach(function (c) { if (gallery[c][0]) preload(sizedSrc(gallery[c][0].src, true)); });
  });
  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (desktop.matches) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== galleryIndex) { galleryIndex = i; markCurrent(); }
      }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (desktop.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      var n = track.children.length;
      galleryIndex = (galleryIndex + (e.key === 'ArrowRight' ? 1 : n - 1)) % n;
      track.scrollTo({ left: galleryIndex * track.clientWidth, behavior: hasMotion ? 'smooth' : 'auto' });
      markCurrent();
    });
  }

  // Colour tone: the studio backdrop and accents take a whisper of the chosen colour; the colour rail
  // marks the chosen card.
  var tones = { Blue: '#36699b', Green: '#9bc45a', Orange: '#d77a2d', Pink: '#d58daf', Red: '#bb3542' };
  var pdpRoot = document.querySelector('.v5-pdp');
  function syncTone() {
    var c = colorSelect.value;
    if (pdpRoot && tones[c]) pdpRoot.style.setProperty('--tone', tones[c]);
    document.querySelectorAll('[data-v6-pick]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v6-pick') === c)); });
  }
  document.querySelectorAll('[data-v6-pick]').forEach(function (button) {
    button.addEventListener('click', function () {
      var color = button.getAttribute('data-v6-pick');
      if (colorSelect.value !== color) { colorSelect.value = color; colorSelect.dispatchEvent(new Event('change', { bubbles: true })); }
      $('buy').scrollIntoView({ behavior: hasMotion ? 'smooth' : 'auto', block: 'start' });
    });
  });

  function refresh() {
    syncSizes();
    var v = selected();
    var rep = representative();
    var leash = window.MitsiLeash ? window.MitsiLeash.item() : null;
    var total = rep.cents + (leash ? leash.meta.cents : 0);
    var busy = form.dataset.busy === 'true';
    $('variant-id').value = v ? v.id : '';
    $('current-color').textContent = colorSelect.value;
    $('current-size').textContent = sizeSelect.value;
    $('pdp-price').textContent = fmt(rep.cents);
    if ($('pdp-was')) { $('pdp-was').textContent = fmt(rep.cmp || 0); $('pdp-was').hidden = !(rep.cmp > rep.cents); }
    $('checkout-btn').textContent = 'Checkout · ' + fmt(total);
    $('checkout-btn').disabled = busy;
    $('add-btn').disabled = busy;
    $('sa-price').textContent = fmt(total);
    $('sa-variant').textContent = 'Vest · ' + (sizeSelect.value || 'choose size');
    $('sa-btn').textContent = v ? 'Checkout · ' + fmt(total) : 'Choose size';
    $('sa-btn').disabled = busy;
    window.NPKit = { on: false, valid: !!(v && v.available), offer: 'vest', extra: leash ? [leash] : null };
    syncSwatches();
    syncTone();
    updateGallery();
    persist();
    window.dispatchEvent(new CustomEvent('mitsi:buying-change', { detail: { offer: 'vest', vestColor: colorSelect.value || null } }));
    requestAnimationFrame(stickyState);
  }

  function checkout() {
    if (focusMissing()) return;
    if (!window.NPKit.valid) {
      $('purchase-error').textContent = 'That combination is unavailable. Choose another color or size.';
      $('purchase-error').hidden = false;
      return;
    }
    if (form.dataset.busy === 'true') return;
    form.dataset.intent = 'checkout';
    form.requestSubmit($('add-btn'));
  }

  [colorSelect, sizeSelect].forEach(function (select) {
    select.addEventListener('change', function () { $('purchase-error').hidden = true; refresh(); });
  });
  window.addEventListener('mitsi:leash-change', function () { $('purchase-error').hidden = true; refresh(); });
  $('checkout-btn').addEventListener('click', checkout);
  $('sa-btn').addEventListener('click', checkout);
  $('add-btn').addEventListener('click', function (event) {
    if (focusMissing()) event.preventDefault();
    else form.dataset.intent = 'cart';
  });

  function stickyState() {
    var rect = $('checkout-btn').getBoundingClientRect();
    $('sticky-atc').classList.toggle('visible', rect.bottom > innerHeight || rect.bottom <= 66);
  }
  addEventListener('scroll', stickyState, { passive: true });
  addEventListener('resize', stickyState);

  refresh();
  stickyState();
})();
